/*
          Author: Vaishnavi
          Date: 18/11/2019
          Issue Description: Visual Bug fixes assigned by Harshvardhan Kore & Tarun Bhandari
          */
<template>
  <div>
    <div class="permission-alert-msg" v-show="!(ifTeamleaderPermission)">
      You have only view permission.
    </div>
    <div class="noData" v-show="ifTeamleaderPermission">
      <br />
      <span class="text">Click on ‘Add New’ to add new Cost Center in the following list</span>
      <button class="addnewbtn" v-if="costCentreData[le_id].length>3" @click="createForm()">
        <img src="@/assets/group-5.svg" />
        <b>Add New</b>
      </button>
    </div>
    <br />
    <div :disabled="!(ifTeamleaderPermission)">
      <div v-if="costCentreData[le_id] ? costCentreData[le_id].length : false">
        <data-table
          :columns="costCentreColumnNames"
          :tableData="costCentreData[le_id]"
          :checkbox="false"
          :withForm="false"
          :showhistory="false"
          @editStart="initEditStart"
          @delete="deleteItem"
        />
      </div>
    </div>
    <form-add-button
      v-if="adddialog &&  costCentreData[le_id].length<=3"
      main_text="+ Add New"
      sub_text="Cost Centre"
      @click="createForm()"
      v-show="ifTeamleaderPermission"
    ></form-add-button>
    <toast-message :message="errmsg" v-show="toast" type="error" />
    <pop-up-message
      v-if="showPopup"
      :message="popupMessage"
      :popupType="popupType"
      :popupHeaderMessage="'Confirm Delete'"
    >
      <!-- Author: Vaishnavi
    Date: 10/12/2019
      Issue Description: Consistent buttons across application-->
      <template v-slot:bottomContent>
        <btn-grp>
          <popup-btn text="Cancel" type="secondary" @click="cancelEvent" />
          <popup-btn text="Delete" type="primary" @click="deleteEvent" />
        </btn-grp>
      </template>
    </pop-up-message>
    <bottom-action-container>
      <btn-skip @navClicked="continuee"></btn-skip>
      <template slot="end">
        <btn-grp>
          <btn text="Previous" type="secondary" @click="previous" />
          <btn text="Next" type="primary" @click="continuee" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapState("onboard/cost_centres", {
      costCentreData: state => state.data,
      isFetching: state => state.isFetching,
      isSaving: state => state.isSaving,
      isDeleting: state => state.isDeleting
    }),
    orgId() {
      return this.$store.getters["onboard/getOrgId"];
    },
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    adddialog() {
      return !this.showForm;
    },
    isLoading() {
      return this.isFetching;
    },
    ifAnchor() {
      return localStorage.getItem("userRole") == "ANCHOR" ? true : false;
    },
    ...mapState("onboard/organization", {
      orgIds: state => state.id,
    }),
    ifTeamleaderPermission() {
      if(this.role === 'ADMIN') {
        return true;
      } else if(this.role === 'TEAMLEADER') {
        if(this.costCentersValue) {
          return true;
        } 
        else {
          return false;
        }
      } else {
        return false
      }

      // if(this.role === 'TEAMLEADER' || this.role === 'ADMIN') {
      //   if(this.costCentersValue) {
      //   return true;
      //   } else {
      //     return false;
      //   }
      // }
      // else {
      //  return true
      // }
    },
    ifSuperAdmin() {
      return localStorage.getItem("userRole") == "SUPERADMIN" ? true : false;
    },
  },
  data() {
    return {
      mode: "add",
      popupType: "Success",
      popupMessage: "",
      showPopup: false,
      showForm: false,
      currentRecord: {},
      errmsg: "",
      toast: false,
      costCentreColumnNames: [
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Description",
          key: "description"
        }
      ],
      costCentersValue: false,
      role: ""
    };
  },
  mounted() {
    this.getOrgLeIdList();
  },
  activated() {
    this.getOrgLeIdList();
  },
  methods: {
    ...mapActions("onboard/cost_centres/", {
      act_delete: "delete",
      act_changeEditMode: "changeEditMode"
    }),

    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    /* function go back to previous page */
    previous() {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/departments`
      });
    },

    /* function to go to next page */
    continuee() {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/designation`
      });
    },

    /* function to hide pop-up */
    cancelEvent() {
      this.showPopup = false;
    },

    /* function to open delete confirmation pop-up */
    deleteItem(record) {
      try {
        this.showPopup = true;
        this.popupType = "ConfirmDelete";
        this.popupMessage = "Are you sure you want to delete ?";
        this.currentRecord = record;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to delete a cost cenre */
    async deleteEvent() {
      try {
        await this.act_delete([this.currentRecord, this.le_id]);
      } catch (err) {
        this.toast = true;
        this.errmsg = err.message;
      }
      this.showPopup = false;
    },

    /* function to go to create cost centre page */
    async createForm() {
      try {
        await this.act_changeEditMode({ editMode: false, record: {} });
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/${this.$route.params.step_name}/addcostcenter`
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err.message;
      }
    },

    /* function to go to update page(create cost centre page) */
    async initEditStart(record) {
      try {
        await this.act_changeEditMode({ editMode: true, record: record });
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/${this.$route.params.step_name}/modifycostcenter`
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err.message;
      }
    },

    async getOrgLeIdList() {
      const org = this.orgIds;
      const le = this.le_id;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.costCentersValue = data.data.user.permissions.cost_centers ? true : false;
      //console.log("PL-3406",data);
    }
  }
};
</script>

<style lang="scss" scoped>
.noData {
  span {
    color: #858585;
    font-size: 14px;
  }
}

p {
  margin-top: 16px;
}
.addnewbtn {
  float: right;
  b {
    color: #34c0be;
    margin-left: 8px;
  }
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
